/** What the loader's caption walks through (there is no real progress to show), holding on the last one. */
export const LOADER_STEPS = [
  'Cargando la casa…',
  'Preparando los jardines…',
  'Encendiendo el Ágora de fuego…',
  'Llenando el lago…',
  'Abriendo el Jardín de las Puertas…',
  'Casi listo…',
];

/** The loader's drawing: its own chunk, started at boot with the rest of Explora. */
export const loadCasaLineas = () => import('./casaLineas');
